export default "__VITE_ASSET__BjaAJzAT__"